/**
 * Chart palette.
 *
 * Categorical slots assigned in fixed order and never cycled. Validated with
 * the data-viz validator against this app's white card surface (#ffffff):
 *
 *   3 slots, all-pairs, light: CVD ΔE 9.2 · normal-vision ΔE 24.0 — PASS
 *   3 slots, all-pairs, dark : CVD ΔE 9.4 · normal-vision ΔE 20.9 — PASS
 *   2 slots, all-pairs, light: CVD ΔE 24.7 · normal-vision ΔE 33.6 — PASS
 *
 * One WARN carries an obligation: aqua sits at 2.82:1 on the light surface,
 * below 3:1. The relief is that every chart here ships a legend AND the same
 * figures as readable numbers (stat tiles, tooltips, or a table), so identity
 * and value are never colour-alone.
 */

export const SERIES = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100'] as const;

/** Fixed per-business colours — identity follows the entity, not its rank. */
export const BUSINESS_COLOR: Record<string, string> = {
  stargym: SERIES[0],
  missfit: SERIES[1],
  starbar: SERIES[2],
  stargroup: SERIES[3],
};

/** The dashboard's two measures. */
export const MEASURE_COLOR = {
  fitimet: SERIES[0],
  shpenzimet: SERIES[1],
} as const;

/** Chart chrome. Deliberately recessive against the data. */
export const CHROME = {
  grid: '#e1e0d9',
  axis: '#c3c2b7',
  muted: '#898781',
  ink: '#0b0b0b',
  surface: '#ffffff',
};

/** Delta cues. Status colours, never reused as a series. */
export const DELTA = {
  good: '#006300',
  bad: '#d03b3b',
};
